import Vue from 'vue'
import VueRouter from 'vue-router'
import Growth from '../views/Growth.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/growth',
    name: 'growth',
    component: Growth,
    meta: {
      title: '一站式私域流量构建服务_未来应用'
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '未来应用'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
